export default function FAQ() {
    return (
        <div>
            This is faq
        </div>
    );
}